// `Symbol.toPrimitive` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.toprimitive
require('../internals/define-well-known-symbol')('toPrimitive');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/es.symbol.to-primitive.js
// module id = 606
// module chunks = 0